import { debris } from "./rocketCrush/debris"
import { boom } from "./rocketCrush/explosion"
import { stopFire } from "./fire/raiseAndSlow"

export class Lose {
  constructor(rocket, boardContainer, setSpeed, isMovingDirectionRight) {
    this.rocket = rocket
    this.boom = boom
    this.boardContainer = boardContainer
    this.debris = debris
    this.ticker = undefined
    this.setSpeed = setSpeed
    this.isMovingDirectionRight = isMovingDirectionRight
  }
  setTickerForLose = (ticker) => (this.ticker = ticker)

  removeDebrisAndBoom = () => {
    this.boardContainer.removeChild(this.debris)
    this.boardContainer.removeChild(this.boom)
  }

  handleLose = () => {
    let { x, y } = this.rocket.position

    this.boardContainer.addChild(this.boom)
    this.boom.gotoAndPlay(0)
    this.boom.position.x = x
    this.boom.position.y = y

    this.boardContainer.removeChild(this.rocket)
    setTimeout(() => {
      this.boardContainer.addChild(this.debris)
      stopFire()
      this.setSpeed(0)
      this.debris.gotoAndPlay(0)
      if (this.isMovingDirectionRight()) {
        this.debris.scale.x = -0.25
      } else {
        this.debris.scale.x = 0.25
      }

      this.debris.position.x = x
      this.debris.position.y = y
    }, 100)
  }
}
